module.exports = {
    COMPOUND: 'compound',
    DATE: 'date',
    GENERIC: 'generic',
    PASSWORD: 'password'
};

